import { useRef, useState } from 'react'
import { Button_Main } from '../components/Button'
import Pagenation from '../components/Pagenation'
import Table from '../components/Table'
import { Main } from '../styles/layout'
import { Table_Info } from '../styles/table'
import { useGetDeviceList } from '../api/main'
import { useLocation } from 'react-router-dom'
import SearchForm, { DefaultParamKeys } from '../components/Search'
import { Dialog } from '../components/Dialog'
import { DeviceCreateForm, DeviceLinkForm, DeviceUpdateForm } from '../components/Form'
import { useAuthCheck } from '../hook'

export const DevicePage = () => {
  const location = useLocation()
  const { checkAuth } = useAuthCheck()
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isLinkOpen, setIsLinkOpen] = useState(false)
  const [isUpdateOpen, setIsUpdateOpen] = useState(false)
  const [updateModalKey, setUpdateModalKey] = useState('')
  const { data, isLoading, isError } = useGetDeviceList(location.search)

  const openUpdateModal = (value:string) =>{
    setUpdateModalKey(value)
    setIsUpdateOpen(true)
  }
  return (
    <Main>
      <h1>단말 관리</h1>
      <SearchForm searchList={searchList}/>
      <Table_Info>
        Total Count: {data?.total}
        {/* {checkAuth('1110') && <Button_Main onClick={() => setIsCreateOpen(true)}>등록</Button_Main>} */}
        {checkAuth('0001') && <Button_Main onClick={() => setIsLinkOpen(true)}>연동</Button_Main>}
      </Table_Info>
      <Table headers={headers} data={data?.data} isLoading={isLoading} isError={isError} rowKey={'macAddress'} modalKey={'deviceId'} onClick={openUpdateModal}/>
      <Pagenation totalPage={data?.totalPage} isLoading={isLoading}/>

      {/* <Dialog $isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)}>
        {isCreateOpen && <DeviceCreateForm onClose={() => setIsCreateOpen(false)} />}
      </Dialog> */}
      <Dialog $isOpen={isLinkOpen} onClose={() => setIsLinkOpen(false)}>
        {isLinkOpen && <DeviceLinkForm onClose={() => setIsLinkOpen(false)} />}
      </Dialog>
      <Dialog $isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
        {isUpdateOpen && <DeviceUpdateForm data={updateModalKey} onClose={() => setIsUpdateOpen(false)} />}
      </Dialog>
    </Main>
  )
}

const headers = [
  { value: 'partName', label: '소속' },
  { value: 'groupName', label: '그룹' },
  { value: 'macAddress', label: 'MAC' },
  { value: 'driveNumber', label: '차량번호' },
  { value: 'deviceAlias', label: '별칭' },
  { value: 'plateNum', label: '펌웨어' },
  { value: 'lastUploadedDate', label: '최근 업로드 일자' },
  { value: 'createdDate', label: '등록일' },
  { value: 'updatedDate', label: '수정일' },
  { value: 'push', label: '요청 Push 전송' },
]

const searchList:DefaultParamKeys[] = [
  'partName',
  'groupName',
  'macAddress',
  'driveNumber'
]


